<template>
  <div id="hotel-chain">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="card-item">
      <div class="card-item-header">
        <label slot="header" class="card-item-title">
          {{
          $t("_HOTEL_CHAIN.TITLE")
          }}
        </label>
      </div>
      <div class="card-item-content">
        <v-row>
          <v-col cols="auto">
            <label class="label-input">{{$t("_HOTEL_CHAIN.CHAIN_NAME")}}</label>
            <input-text
              :model.sync="data.chainName"
              :error.sync="error.chainName.error"
              class="input-chain"
            />
          </v-col>
          <v-col align-self="end">
            <button @click="save" class="ml-5 main-btn btn-pmirary">{{$t('SAVE')}}</button>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="text-chain-list">{{$t("_HOTEL_CHAIN.CHAIN_LIST", {total: total})}}</span>
          </v-col>
        </v-row>

        <template v-for="(hotel, i) in hotels">
          <v-row :key="i">
            <v-col cols="4">
              <span class="d-block">{{hotel.name}}</span>
              <span class="text-chain-list">{{$t('_HOTEL_CHAIN.HOTEL_ID') + hotel.id}}</span>
            </v-col>
            <v-col cols="2">
              <a
                @click="openLoginHotelDialog(hotel)"
                href="javascript:;"
                :class="{'disabled': isCurrentHotel(hotel)}"
                class="card-value link-primary"
              >{{$t("_HOTEL_CHAIN.LOGIN")}}</a>
            </v-col>
            <v-col cols="2">
              <a
                @click="openDeleteHotelDialog(hotel)"
                href="javascript:;"
                v-if="!isCurrentHotel(hotel)"
                class="card-value link-danger"
              >{{$t("_HOTEL_CHAIN.DELETE_HOTEL")}}</a>
            </v-col>
          </v-row>
        </template>

        <v-row>
          <v-col>
            <button
              @click="showAddHotel"
              class="main-btn btn-pmirary"
            >{{$t('_HOTEL_CHAIN.ADD_HOTEL')}}</button>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- Add hotel dialog -->
    <v-dialog v-model="addHotelDialog" max-width="420" content-class="dialog-confirm">
      <v-card>
        <span>{{$t('_HOTEL_CHAIN.LOGIN_TEXT')}}</span>
        <v-row>
          <v-col>
            <span>{{$t('_HOTEL_CHAIN.USERNAME')}}</span>
            <input-text :model.sync="dataLogin.username" :error.sync="errorLogin.username.error" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span>{{$t('_HOTEL_CHAIN.PASSWORD')}}</span>
            <input-text
              type="password"
              :model.sync="dataLogin.password"
              :error.sync="errorLogin.password.error"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="btn-right-wrapper">
            <button
              class="main-btn btn-secondary mr-5"
              @click="addHotelDialog = false"
            >{{$t('CLOSE')}}</button>
            <button class="main-btn btn-pmirary" @click="addHotel">{{$t('_HOTEL_CHAIN.CONFIRM')}}</button>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- Login hotel dialog -->
    <v-dialog v-model="loginHotelDialog" max-width="420" content-class="dialog-confirm">
      <v-card>
        <span
          v-if="selectedHotel"
        >{{$t('_HOTEL_CHAIN.LOGIN_EXISTED_TEXT', {hotelName: selectedHotel.name})}}</span>
        <v-row>
          <v-col>
            <span>{{$t('_HOTEL_CHAIN.USERNAME')}}</span>
            <input-text v-if="dataLogin.username" :model.sync="dataLogin.username" disabled />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span>{{$t('_HOTEL_CHAIN.PASSWORD')}}</span>
            <input-text
              type="password"
              :model.sync="dataLogin.password"
              :error.sync="errorLogin.password.error"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="btn-right-wrapper">
            <button
              class="main-btn btn-secondary mr-5"
              @click="loginHotelDialog = false"
            >{{$t('CLOSE')}}</button>
            <button class="main-btn btn-pmirary" @click="loginHotel">{{$t('_HOTEL_CHAIN.LOGIN')}}</button>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- Remove hotel dialog -->
    <v-dialog v-model="removeHotelDialog" max-width="280" content-class="dialog-confirm">
      <v-card>
        <span>{{$t('_HOTEL_CHAIN.REMOVE_HOTEL')}}</span>
        <v-row>
          <v-col class="btn-right-wrapper">
            <button
              class="main-btn btn-secondary mr-5"
              @click="removeHotelDialog = false"
            >{{$t('CLOSE')}}</button>
            <button class="main-btn btn-danger" @click="deleteHotel">{{$t('DELETE')}}</button>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
#hotel-chain {
  .main-btn {
    padding: 7px 32px !important;
  }
  .input-chain {
    width: 300px;
  }
  .text-chain-list {
    font-size: 14px;
    color: #808080;
  }
  a {
    text-decoration: underline;
    &.link-primary {
      color: #173d8f;
    }
    &.link-danger {
      color: #d9390d;
    }
  }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
</style>

<script>
import Input from "@/components/Utils/Input.vue";
import {
  getHotelChainNameError,
  getHotelChainError
} from "@/_helpers/config.js";
import { service } from "@/_services/GeneralInfomation/hotel-chain.service.js";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { authenticationService } from "@/_services";
import eventBus from "@/_helpers/event-bus.js";

export default {
  components: {
    "input-text": Input
  },
  data() {
    return {
      isLoading: false,
      isDisabled: true,
      lang: this.$i18n.locale,
      data: {},
      error: getHotelChainNameError(),
      dataLogin: {},
      errorLogin: getHotelChainError(),
      hotels: [],
      total: 1,
      selectedHotel: null,
      addHotelDialog: false,
      loginHotelDialog: false,
      removeHotelDialog: false,
      currentUser: JSON.parse(localStorage.getItem("currentUser")) || {}
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    // Run when start
    initialize() {
      this.getHotelChainDetail();
    },
    // Get hotel chain info
    getHotelChainDetail() {
      this.isLoading = true;
      service
        .getHotelChainDetail()
        .then(res => {
          if (res.responseCode === 0) {
            if (res.data) {
              this.data = res.data;
              this.hotels = res.data.hotels || [];
              this.total = this.hotels.length;
            } else {
              const lang = this.$i18n.locale;
              this.data = {
                chainName: "",
                hotels: []
              };
              this.hotels = [];
              this.hotels.push({
                id: this.currentUser.hotel.id,
                name: this.currentUser.hotel.i18ns.find(x => x.lang === lang)
                  .name,
                username: this.currentUser.user.username
              });
              this.total = 1;
            }
            this.isDisabled = this.total <= 1;
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Check is current hotel
    isCurrentHotel(hotel) {
      return hotel.id === this.currentUser.hotel.id;
    },
    showAddHotel() {
      this.addHotelDialog = true;
      this.dataLogin.username = null;
      this.dataLogin.password = null;
    },
    // Add new hotel
    addHotel() {
      // Validate
      let { isValid, error } = _validateFormI18n(
        this.dataLogin,
        this.errorLogin
      );
      this.errorLogin = error;
      if (!isValid) return false;
      // Add hotel
      this.addHotelDialog = false;
      this.isLoading = true;
      service
        .addHotel(this.dataLogin)
        .then(res => {
          if (res.responseCode === 0) {
            _alert(res, this.$t("CREATE_SUCCESS"), false);
            this.initialize();
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => location.reload());
    },
    // Open login hotel dialog
    openLoginHotelDialog(hotel) {
      if (this.isCurrentHotel(hotel)) {
        return;
      }
      this.selectedHotel = hotel;
      this.dataLogin.username = hotel.username;
      this.dataLogin.password = null;
      this.loginHotelDialog = true;
    },
    // Open delete hotel dialog
    openDeleteHotelDialog(hotel) {
      this.selectedHotel = hotel;
      this.removeHotelDialog = true;
    },
    // Login hotel
    loginHotel() {
      // Validate
      let { isValid, error } = _validateFormI18n(
        this.dataLogin,
        this.errorLogin
      );
      this.errorLogin = error;
      if (!isValid) return false;
      // Login hotel
      this.isLoading = true;
      authenticationService
        .login(this.dataLogin.username, this.dataLogin.password)
        .then(res => {
          if (res.responseCode === 0) {
            this.loginHotelDialog = false;
            localStorage.setItem("userInfo", JSON.stringify(res.data));
            localStorage.setItem("jwt", res.data.token);
            this.$router.push("dashboard");
            eventBus.$emit("EVENT_RELOAD_USER");
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Delete hotel
    deleteHotel() {
      this.removeHotelDialog = false;
      if (!this.selectedHotel) {
        return;
      }
      this.isLoading = true;
      service
        .removeHotel(this.selectedHotel.id)
        .then(res => {
          if (res.responseCode === 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    },
    // Save
    save() {
      // Validate
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;
      if (!isValid) return false;
      this.isLoading = true;
      let temp = {
        chainName: this.data.chainName,
        hotels: this.hotels
      };
      // temp.hotels.push({
      //   id: this.currentUser.hotel.id,
      //   name: this.currentUser.hotel.i18ns.find(x => x.lang === this.lang).name,
      //   username: this.currentUser.user.username
      // });
      service
        .saveHotelChain(temp)
        .then(res => {
          if (res.responseCode === 0) {
            this.initialize();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
